module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as2808-1236181f13981681d36782337d735eee.jpg";